import IndustryBenefitsI18n from "@/components/landing/shared/IndustryBenefitsI18n";
import { TrendingUp, Heart, PiggyBank, Users } from "lucide-react";
const VorteileSection = () => <IndustryBenefitsI18n translationPrefix="industryMaschinenbau" icons={[TrendingUp, Heart, PiggyBank, Users]} />;
export default VorteileSection;
